const map = {
	"./core/blue_team_no_background.webp": 21355,
	"./core/player-frame.webp": 68369,
	"./core/red_team_no_background.webp": 72350,
	"./features/excalibur.webp": 56271,
	"./features/lady_of_lake.webp": 77194,
	"./features/lady_of_sea.webp": 16964,
	"./features/plot_cards.webp": 87191,
	"./features/trapper.webp": 6126,
	"./roles/anime/brute.webp": 20165,
	"./roles/anime/cleric.webp": 95139,
	"./roles/anime/evil_lancelot.webp": 23972,
	"./roles/anime/good_lancelot.webp": 50817,
	"./roles/anime/guinevere.webp": 49787,
	"./roles/anime/isolde.webp": 62499,
	"./roles/anime/lunatic.webp": 39503,
	"./roles/anime/merlin.webp": 94916,
	"./roles/anime/merlin_pure.webp": 57551,
	"./roles/anime/minion.webp": 4557,
	"./roles/anime/mordred.webp": 30316,
	"./roles/anime/morgana.webp": 5130,
	"./roles/anime/mystery.webp": 18708,
	"./roles/anime/oberon.webp": 62484,
	"./roles/anime/percival.webp": 44901,
	"./roles/anime/revealer.webp": 27129,
	"./roles/anime/revealer_hidden.webp": 37402,
	"./roles/anime/revealer_progress.webp": 29989,
	"./roles/anime/servant.webp": 98368,
	"./roles/anime/trickster.webp": 31390,
	"./roles/anime/tristan.webp": 82684,
	"./roles/anime/troublemaker.webp": 22906,
	"./roles/anime/unknown_lancelot.webp": 55862,
	"./roles/anime/witch.webp": 66898,
	"./roles/anime/wraith.webp": 94960,
	"./roles/brute.webp": 74946,
	"./roles/cleric.webp": 47286,
	"./roles/evil_lancelot.webp": 88815,
	"./roles/good_lancelot.webp": 89194,
	"./roles/guinevere.webp": 604,
	"./roles/isolde.webp": 93030,
	"./roles/legacy/brute.webp": 1946,
	"./roles/legacy/cleric.webp": 71230,
	"./roles/legacy/evil_lancelot.webp": 58007,
	"./roles/legacy/good_lancelot.webp": 34290,
	"./roles/legacy/guinevere.webp": 87380,
	"./roles/legacy/isolde.webp": 51070,
	"./roles/legacy/lunatic.webp": 71332,
	"./roles/legacy/merlin.webp": 48773,
	"./roles/legacy/merlin_pure.webp": 45068,
	"./roles/legacy/minion.webp": 13104,
	"./roles/legacy/mordred.webp": 61983,
	"./roles/legacy/morgana.webp": 69269,
	"./roles/legacy/mystery.webp": 72411,
	"./roles/legacy/oberon.webp": 45041,
	"./roles/legacy/percival.webp": 10060,
	"./roles/legacy/revealer.webp": 40020,
	"./roles/legacy/revealer_hidden.webp": 37129,
	"./roles/legacy/revealer_progress.webp": 98510,
	"./roles/legacy/servant.webp": 51299,
	"./roles/legacy/trickster.webp": 2373,
	"./roles/legacy/tristan.webp": 97467,
	"./roles/legacy/troublemaker.webp": 83379,
	"./roles/legacy/unknown_lancelot.webp": 37835,
	"./roles/legacy/witch.webp": 30149,
	"./roles/legacy/wraith.webp": 98857,
	"./roles/lunatic.webp": 62780,
	"./roles/merlin.webp": 25981,
	"./roles/merlin_pure.webp": 15588,
	"./roles/minion.webp": 14984,
	"./roles/mordred.webp": 72167,
	"./roles/morgana.webp": 28781,
	"./roles/mystery.webp": 96851,
	"./roles/oberon.webp": 95257,
	"./roles/percival.webp": 15172,
	"./roles/revealer.webp": 41372,
	"./roles/revealer_hidden.webp": 12705,
	"./roles/revealer_progress.webp": 13862,
	"./roles/servant.webp": 12251,
	"./roles/trickster.webp": 96333,
	"./roles/tristan.webp": 40003,
	"./roles/troublemaker.webp": 971,
	"./roles/unknown_lancelot.webp": 30243,
	"./roles/witch.webp": 46413,
	"./roles/wraith.webp": 63681
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 82349;